export default __webpack_public_path__ + "static/media/artikelstream.ae01a7f4.svg";